import { getRequest as axiosGetRequest } from '../clients/axios';
import { parseError } from '@/utils';
import { APIRequestError } from '../errors/apiRequest';

// return Array<T>
export const getRequest = async <T>(name: string, url: string) => {
  try {
    const response = (await axiosGetRequest(url)).data as Array<T>;
    return response;
  } catch (error) {
    const errorMessage = `Error while doing ${name} request: ${parseError(error)}`;
    console.error(errorMessage);
    throw new APIRequestError(name, errorMessage, error);
  }
};

// return T
export const getRequestSingle = async <T>(name: string, url: string) => {
  try {
    const response = (await axiosGetRequest(url)).data as T;
    return response;
  } catch (error) {
    const errorMessage = `Error while doing ${name} request: ${parseError(error)}`;
    console.error(errorMessage);
    throw new APIRequestError(name, errorMessage, error);
  }
};
